<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Periode Penggajian
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Daftar Periode Penggajian</h5>
    </div>

    <LogPopupTemplate ref="logPopup" />
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <dx-popup
          :visible="popupLoadingVisible"
          title="Generating gaji..."
          :drag-enabled="false"
          :hide-on-outside-click="false"
          width="300"
          :height="130"
        >
          <div class="d-flex justify-content-center">
            <div
              class="spinner-border"
              style="width: 3rem; height: 3rem"
              role="status"
            ></div>
          </div>
        </dx-popup>

        <dx-popup
          :visible="popupWarningVisible"
          title="Konfirmasi data pegawai"
          :drag-enabled="false"
          :hide-on-outside-click="false"
          width="400"
          :height="200"
        >
          <div>
            <p>
              <strong>Mohon cek kelengkapan data pegawai dan absensi</strong>
            </p>
            <p>
              <strong
                >Update data pekerjaan, KP dan KGB ke versi terbaru</strong
              >
            </p>
          </div>
          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="cancelButtonOptions"
          />

          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="confirmButtonOptionsWarning"
          />
        </dx-popup>

        <DxPopup
          :visible="popupVisible"
          title="Tambah data"
          :drag-enabled="false"
          :hide-on-outside-click="false"
          :height="650"
        >
          <!-- :width="550" -->
          <div class="dx-fieldset">
            <div class="dx-field">
              <div class="dx-field-label">Periode penggajian</div>
              <div class="dx-field-value">
                <DxDateBox
                  :show-clear-button="true"
                  :use-mask-behavior="true"
                  :input-attr="{ 'aria-label': 'Date' }"
                  type="date"
                  displayFormat="monthAndYear"
                  :calendar-options="calendarMonthYear"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.tgl"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                </DxDateBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Pokok</div>
              <div class="dx-field-value">
                <DxSelectBox
                  @opened="loadGajiPokokSkema"
                  :dataSource="gajiPokokSkemaStore"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_pokok_skema_id"
                  item-template="customItemGapok"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                  <template #customItemGapok="{ data: itemData }">
                    <div class="custom-item">
                      <img
                        alt="Lihat Gapok"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat Gapok"
                        @click="lihatGapok(itemData)"
                      />
                      <span>{{ itemData.nama }}</span>
                    </div>
                  </template>
                </DxSelectBox>
              </div>
            </div>
          </div>
          <div class="dx-fieldset">
            <div class="dx-fieldset-header">
              Skema penggajian untuk masing-masing status pegawai
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Direktur Utama</div>
              <div class="dx-field-value">
                <!-- :dataSource="commonStore.gajiSkemaDirutStore" -->
                <DxSelectBox
                  @opened="loadGajiSkemaDirut"
                  :dataSource="gajiSkemaDirutStore"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_dirut_id"
                  item-template="customItem"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                  <template #customItem="{ data: itemData }">
                    <div class="custom-item">
                      <img
                        alt="Lihat Rumus"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat Rumus"
                        @click="lihatRumus(itemData)"
                      />
                      <span class="custom-text">{{ itemData.nama }}</span>
                    </div>
                  </template>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Direktur Umum</div>
              <div class="dx-field-value">
                <DxSelectBox
                  @opened="loadGajiSkemaDirum"
                  :dataSource="gajiSkemaDirumStore"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_dirum_id"
                  item-template="customItem"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                  <template #customItem="{ data: itemData }">
                    <div class="custom-item">
                      <img
                        alt="Lihat Rumus"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat Rumus"
                        @click="lihatRumus(itemData)"
                      />
                      <span class="custom-text">{{ itemData.nama }}</span>
                    </div>
                  </template>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Direktur Teknik</div>
              <div class="dx-field-value">
                <DxSelectBox
                  @opened="loadGajiSkemaDirtek"
                  :dataSource="gajiSkemaDirtekStore"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_dirtek_id"
                  item-template="customItem"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                  <template #customItem="{ data: itemData }">
                    <div class="custom-item">
                      <img
                        alt="Lihat Rumus"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat Rumus"
                        @click="lihatRumus(itemData)"
                      />
                      <span class="custom-text">{{ itemData.nama }}</span>
                    </div>
                  </template>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Dewan Pengawas</div>
              <div class="dx-field-value">
                <DxSelectBox
                  @opened="loadGajiSkemaDewas"
                  :dataSource="gajiSkemaDewasStore"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_dewas_id"
                  item-template="customItem"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                  <template #customItem="{ data: itemData }">
                    <div class="custom-item">
                      <img
                        alt="Lihat Rumus"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat Rumus"
                        @click="lihatRumus(itemData)"
                      />
                      <span class="custom-text">{{ itemData.nama }}</span>
                    </div>
                  </template>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Pegawai Tetap</div>
              <div class="dx-field-value">
                <DxSelectBox
                  @opened="loadGajiSkemaTetap"
                  :dataSource="gajiSkemaTetapStore"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_tetap_id"
                  item-template="customItem"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                  <template #customItem="{ data: itemData }">
                    <div class="custom-item">
                      <img
                        alt="Lihat Rumus"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat Rumus"
                        @click="lihatRumus(itemData)"
                      />
                      <span class="custom-text">{{ itemData.nama }}</span>
                    </div>
                  </template>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Pegawai Capeg</div>
              <div class="dx-field-value">
                <DxSelectBox
                  @opened="loadGajiSkemaCapeg"
                  :dataSource="gajiSkemaCapegStore"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_capeg_id"
                  item-template="customItem"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                  <template #customItem="{ data: itemData }">
                    <div class="custom-item">
                      <img
                        alt="Lihat Rumus"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat Rumus"
                        @click="lihatRumus(itemData)"
                      />
                      <span class="custom-text">{{ itemData.nama }}</span>
                    </div>
                  </template>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Pekerja Honor</div>
              <div class="dx-field-value">
                <DxSelectBox
                  @opened="loadGajiSkemaHonor"
                  :dataSource="gajiSkemaHonorStore"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_honor_id"
                  item-template="customItem"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                  <template #customItem="{ data: itemData }">
                    <div class="custom-item">
                      <img
                        alt="Lihat Rumus"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat Rumus"
                        @click="lihatRumus(itemData)"
                      />
                      <span class="custom-text">{{ itemData.nama }}</span>
                    </div>
                    <!-- <div class="custom-item">
                      <img
                        alt="Lihat Rumus"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat rumus"
                        @click="lihatRumus(itemData)"
                      />
                      <div class="product-name">
                        {{ itemData.nama }}
                      </div>
                    </div> -->
                  </template>
                </DxSelectBox>
              </div>
            </div>

            <div class="dx-field">
              <div class="dx-field-label">Skema Gaji Pekerja Kontrak</div>
              <div class="dx-field-value">
                <DxSelectBox
                  @opened="loadGajiSkemaKontrak"
                  :dataSource="gajiSkemaKontrakStore"
                  valueExpr="id"
                  displayExpr="nama"
                  :searchEnabled="true"
                  searchExpr="nama"
                  search-mode="startswith"
                  :styling-mode="stylingMode"
                  :label-mode="labelMode"
                  width="100%"
                  v-model="gajiPeriode.gaji_skema_kontrak_id"
                  item-template="customItem"
                >
                  <DxValidator>
                    <DxRequiredRule />
                  </DxValidator>
                  <template #customItem="{ data: itemData }">
                    <div class="custom-item">
                      <img
                        alt="Lihat Rumus"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat Rumus"
                        @click="lihatRumus(itemData)"
                      />
                      <span class="custom-text">{{ itemData.nama }}</span>
                    </div>
                    <!-- <div class="custom-item">
                      <img
                        alt="Lihat Rumus"
                        src="./eye-solid.png"
                        class="clickable-image"
                        title="Lihat rumus"
                        @click="lihatRumus(itemData)"
                      />
                      <div class="product-name">
                        {{ itemData.nama }}
                      </div>
                    </div> -->
                  </template>
                </DxSelectBox>
              </div>
            </div>
          </div>

          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="before"
            :options="cancelButtonOptions"
          />

          <DxToolbarItem
            widget="dxButton"
            toolbar="bottom"
            location="after"
            :options="confirmButtonOptions"
          />
        </DxPopup>

        <DxPopup
          :height="900"
          :show-title="true"
          :title="popupRumusTitle"
          :drag-enabled="false"
          :hide-on-outside-click="true"
          v-model:visible="popupRumusVisible"
        >
          <template #content>
            <div
              v-if="
                !popupGapokVisible &&
                gajiSkemaKomponenStore &&
                gajiSkemaKomponenStore.length > 0
              "
            >
              <RumusListTemplate
                :gajiSkemaId="popupGajiSkemaId"
                :gajiSkemaKomponenStore="
                  commonFunction.filteredGajiSkemaKomponenStore(
                    gajiSkemaKomponenStore,
                    popupGajiSkemaId,
                  )
                "
              />
            </div>
            <div
              v-if="
                popupGapokVisible &&
                gajiPokokSkemaDetailStore &&
                gajiPokokSkemaDetailStore.length > 0
              "
            >
              <!-- <table class="table table-bordered table-hover table-striped">
                <thead>
                  <tr>
                    <th>MK</th>
                    <th
                      v-for="golongan in commonStore.golonganStore"
                      :key="golongan.id"
                    >
                      {{ golongan.nama }}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="mk in masaKerjaRange" :key="mk">
                    <td>
                      <strong>{{ mk }}</strong>
                    </td>
                    <td
                      v-for="golongan in commonStore.golonganStore"
                      :key="golongan.id"
                    >
                      {{ lihatGapokDetail(mk, golongan) }}
                    </td>
                  </tr>
                </tbody>
              </table> -->
              <GajiPokokTableTemplate
                :gajiPokokId="popupGapokId"
                :gajiPokokSkemaDetailStore="
                  commonFunction.filteredGajiPokokSkemaDetailStore(
                    gajiPokokSkemaDetailStore,
                    popupGapokId,
                  )
                "
              />
            </div>

            <div v-else class="p-4 text-center text-muted">
              <div
                class="spinner-border"
                style="width: 3rem; height: 3rem"
                role="status"
              ></div>
            </div>
          </template>
        </DxPopup>

        <DxDataGrid
          ref="gridRef"
          id="gridContainer"
          :data-source="gajiPeriodeListStore.dataSourceGajiPeriodeList"
          :allow-column-reordering="true"
          :show-borders="true"
          @editor-preparing="oneditorpreparing"
          :focused-row-index="0"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged"
          :filter-sync-enabled="true"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :remote-operations="true"
          :scrolling="{
            mode: 'virtual',
            rowRenderingMode: 'virtual',
            columnRenderingMode: 'virtual',
            useNative: true,
          }"
          @context-menu-preparing="onContextMenuPreparing($event)"
        >
          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem template="add-template" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('gridRef')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <template #add-template>
            <DxButton
              v-if="can('gaji-create')"
              icon="add"
              @click="addPeriodeVisible()"
              text="Tambah Data"
              type="default"
              style="float: left"
              width="150px"
              styling-mode="filled"
            ></DxButton>
          </template>

          <!-- <DxFilterRow :visible="showFilterRow" :apply-filter="currentFilter" /> -->
          <!-- <dx-pager :show-page-size-selector="true" :show-info="true" /> -->
          <!-- <DxPaging :enabled="true" :page-size="10" /> -->
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
          />

          <DxHeaderFilter :visible="true" />
          <DxScrolling mode="virtual" />
          <DxFilterRow :visible="true" apply-filter="auto" />
          <DxPager
            :visible="true"
            :showPageSizeSelector="false"
            :showNavigationButtons="false"
            :show-info="true"
            :infoText="'Page {0} of {1} ({2} items)'"
          />
          <DxPaging :enabled="true" :page-size="numberingPageSize" />

          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />
          <!-- <DxColumn
            caption="#"
            data-field="created_at"
            cell-template="numberingTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
          />
          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template> -->

          <DxColumn
            class="noteditable"
            caption="#"
            data-field="row_number"
            :allow-filtering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :fixed="true"
            fixed-position="left"
            data-type="number"
          />
          <DxColumn
            :allowHeaderFiltering="false"
            data-field="tgl"
            caption="Periode Penggajian"
            data-type="date"
            :display-format="'MM/yyyy'"
            :format="'MM/yyyy'"
            sort-order="desc"
            :customizeText="commonFunction.formatIsoDateToMonthYear"
          />
          <template #tglGajiTemplate="{ data }">
            {{ formatMonth(data.text) }}
          </template>
          <DxColumn
            data-field="gaji_statuses_nama"
            caption="Status Penggajian"
            data-type="string"
            cell-template="statusTemplate"
            :allowHeaderFiltering="true"
            :header-filter="{ dataSource: commonStore.penggajianStatusSource }"
          >
          </DxColumn>
          <dx-column
            data-type="number"
            caption="Pengaturan penggajian"
            :cell-template="gajiTemplate"
          >
          </dx-column>
          <DxColumn
            caption="Dibuat oleh"
            :allowHeaderFiltering="false"
            data-field="created_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <DxColumn
            caption="Diubah oleh"
            :allowHeaderFiltering="false"
            data-field="updated_at_text"
            :allowFiltering="false"
            :allow-sorting="false"
            :allow-exporting="false"
            :allow-updating="false"
          />

          <dx-column caption="Daftar gaji" cell-template="gajiListTemplate">
          </dx-column>

          <template #gajiListTemplate="{ data }">
            <DxButton
              @click="clickGaji(data)"
              :text="gajiListTemplate(data, 'text')"
              :type="gajiListTemplate(data, 'type')"
              style="float: left"
              width="150px"
              styling-mode="filled"
              :visible="gajiListTemplate(data, 'visible')"
            ></DxButton>
          </template>

          <!-- <template #createdTemplate="{ data }">
            <div v-html="userPrint(data, 'created')"></div>
          </template> -->

          <!-- <template #updatedTemplate="{ data }">
            <div v-html="userPrint(data, 'updated')"></div>
          </template> -->

          <template #statusTemplate="{ data }">
            <DxButton
              :text="buttonStatus(data, 'text')"
              :type="buttonStatus(data, 'type')"
              width="auto"
              height="18px"
            />
          </template>

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="id"
            data-type="number"
            caption=" "
            :allow-exporting="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              style="margin: auto; display: block"
              :items="getOptions(data)"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick($event, data)"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.custom-itemAsli {
  display: flex;
  align-items: center; /* Vertically center items */
  width: 100%; /* Full width container */
}

.custom-itemAsli img {
  float: right;
  // width: 24px; /* Match the line height */
  height: 24px; /* Match the line height */
  cursor: pointer; /* Change cursor to pointer on hover */
  transition: transform 0.2s ease; /* Smooth transition for hover effect */
}

.clickable-image:hover {
  transform: scale(1.1); /* Slightly enlarge the image on hover */
}

.custom-itemAsli .product-nameAsli {
  line-height: 24px;
  // padding-left: 5px;
}

.custom-item {
  display: flex;
  align-items: center; /* Align image and text vertically */
}

.clickable-image {
  // height: 2em; /* Matches the font size of the text */
  height: 24px;
  width: auto; /* Maintain aspect ratio */
  margin-right: 1em; /* Space between the image and text */
  cursor: pointer; /* Show pointer cursor for clickable image */
}

.custom-text {
  // font-size: 2em; /* Ensure text size matches the image size */
  // line-height: 2em; /* Align text vertically with the image */
  line-height: 24px;
}

// thead th {
//   position: sticky;
//   top: 0;
//   z-index: 100;
//   background-color: white;
//   border: 1px solid #ddd;
// }

/* Sticky first column in the header */
// thead th:first-child {
//   position: sticky;
//   left: 0;
//   z-index: 102; /* Higher z-index so it stays on top */
//   background-color: white;
// }

/* Sticky first column in the body */
// tbody td:first-child {
//   position: sticky;
//   left: 0;
//   z-index: 101;
//   background-color: white;
//   border: 1px solid #ddd;
// }
</style>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import GajiPokokTableTemplate from "./GajiPokokTableTemplate.vue";
import RumusListTemplate from "./RumusListTemplate.vue";
import * as commonFunction from "@/utils/common-function.js";
import { useGajiPeriodeListStore } from "@/stores/views/gaji-periode-list-store";
import { useCommonStore } from "@/stores/utility/common-store2";
import api from "@/api";
import _ from "lodash";
import can from "@/haspermission";
import { DateTime } from "luxon";
import { API_BASE_URL } from "@/global-constants";
import DxButton from "devextreme-vue/button";
import router from "@/router";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxPager,
  DxToolbar,
  DxItem,
  DxHeaderFilter,
  DxScrolling,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { DxPopup, DxToolbarItem } from "devextreme-vue/popup";
import DxDateBox from "devextreme-vue/date-box";
import DxSelectBox from "devextreme-vue/select-box";
import { DxValidator, DxRequiredRule } from "devextreme-vue/validator";

import notify from "devextreme/ui/notify";
import auth from "../auth";
import axios from "axios";
import { useGajiSettingStore } from "@/stores/views/gaji-setting-store";
// import { custom } from "devextreme/ui/dialog";

export default {
  components: {
    LogPopupTemplate,
    GajiPokokTableTemplate,
    RumusListTemplate,
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxPager,
    DxDropDownButton,
    DxButton,

    DxToolbar,
    DxItem,

    DxPopup,
    DxToolbarItem,
    DxDateBox,
    DxSelectBox,
    DxValidator,
    DxRequiredRule,
    DxHeaderFilter,
    DxScrolling,
  },
  setup() {
    const commonStore = useCommonStore();
    const gajiPeriodeListStore = useGajiPeriodeListStore();
    const gajiSettingStore = useGajiSettingStore();

    const masaKerjaRange = Array.from({ length: 34 }, (_, i) => i);

    return {
      gajiSettingStore,
      gajiPeriodeListStore,
      commonFunction,
      commonStore,
      masaKerjaRange,
    };
  },

  data() {
    return {
      logPopupRef: null,
      isLoadingKomponen: false,
      gajiPokokSkemaStore: null,
      gajiSkemaDirutStore: null,
      gajiSkemaDirumStore: null,
      gajiSkemaDirtekStore: null,
      gajiSkemaDewasStore: null,
      gajiSkemaTetapStore: null,
      gajiSkemaCapegStore: null,
      gajiSkemaHonorStore: null,
      gajiSkemaKontrakStore: null,
      gajiSkemaKomponenStore: null,
      gajiPokokSkemaDetailStore: null,
      stylingMode: "outlined",
      //outlined, filled, underlined
      labelMode: "floating",

      calendarMonthYear: {
        maxZoomLevel: "year",
        minZoomLevel: "century",
      },

      gajiPeriode: {
        tgl: null,
        gaji_status_id: 1, //open untuk periode baru
        created_by_user_id: auth.getUser().id,
        gaji_pokok_skema_id: null,
        gaji_skema_dirut_id: null,
        gaji_skema_dirum_id: null,
        gaji_skema_dirtek_id: null,
        gaji_skema_tetap_id: null,
        gaji_skema_capeg_id: null,
        gaji_skema_honor_id: null,
        gaji_skema_kontrak_id: null,
      },
      popupVisible: false,
      popupRumusVisible: false,
      popupRumusTitle: null,
      popupGapokVisible: false,
      rumusSource: null,
      popupGajiSkemaId: null,
      popupWarningVisible: false,
      popupLoadingVisible: false,
      cancelButtonOptions: {
        text: "Close",
        type: "danger",
        onClick: () => {
          this.popupVisible = false;
          this.popupWarningVisible = false;
        },
      },

      confirmButtonOptions: {
        text: "Simpan",
        onClick: (e) => {
          this.addPeriode(e);
        },
      },
      confirmButtonOptionsWarning: {
        text: "Ya, Data Pegawai terupdate",
        onClick: () => {
          this.absenCheckExists();
          this.popupWarningVisible = false;
        },
      },

      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],
      numberingPageSize: 10,
      numberingPageNumber: 0,
      router: router,

      // pegawaiSource: new ODataStore({
      //   url: "http://127.0.0.1/odata/SimpegPegawais",
      //   key: "id",
      // }),
      editingOptions: {},
      showFilterRow: true,
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target,
      ) {
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterBuilder") {
          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterBuilder") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterBuilder") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(tgl) lt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterBuilder") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(tgl) gt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (
          selectedFilterOperation === "between" &&
          target == "filterBuilder"
        ) {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(tgl) ge " +
              bulan1 +
              " and year(tgl) ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(tgl) le " +
              bulan2 +
              " and year(tgl) le " +
              filterValue[1].getFullYear(),
          ];
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },
      oneditorpreparing: function (e) {
        if (e.dataField === "tgl") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
      gajiPeriodeId: null,
      gajiPeriodeTgl: null,
    };
  },
  watch: {
    popupRumusVisible: {
      async handler(visible) {
        if (
          visible &&
          (!this.gajiSkemaKomponenStore ||
            this.gajiSkemaKomponenStore.length === 0)
        ) {
          this.isLoadingKomponen = true;
          this.gajiSkemaKomponenStore =
            await this.gajiSettingStore.getGajiSkemaKomponen();
          this.isLoadingKomponen = false;
        }

        if (
          visible &&
          (!this.gajiPokokSkemaDetailStore ||
            this.gajiPokokSkemaDetailStore.length === 0)
        ) {
          this.isLoadingKomponen = true;
          this.gajiPokokSkemaDetailStore =
            await this.gajiSettingStore.getGajiPokokSkemaDetail();
          this.isLoadingKomponen = false;
        }
      },
      immediate: false,
    },
  },
  async created() {
    await this.commonStore.preloadStores();
  },

  async mounted() {
    console.log("status", this.commonStore.penggajianStatusStore);
  },
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },
  methods: {
    async loadGajiPokokSkema() {
      if (!this.gajiPokokSkemaStore) {
        this.gajiPokokSkemaStore =
          await this.gajiSettingStore.getGajiPokokSkema();
      }
    },
    async loadGajiSkemaDirut() {
      if (!this.gajiSkemaDirutStore) {
        this.gajiSkemaDirutStore =
          await this.gajiSettingStore.getGajiSkemaDirut();
      }
    },

    async loadGajiSkemaDirtek() {
      if (!this.gajiSkemaDirtekStore) {
        this.gajiSkemaDirtekStore =
          await this.gajiSettingStore.getGajiSkemaDirtek();
      }
    },

    async loadGajiSkemaDirum() {
      if (!this.gajiSkemaDirumStore) {
        this.gajiSkemaDirumStore =
          await this.gajiSettingStore.getGajiSkemaDirum();
      }
    },

    async loadGajiSkemaDewas() {
      if (!this.gajiSkemaDewasStore) {
        this.gajiSkemaDewasStore =
          await this.gajiSettingStore.getGajiSkemaDewas();
      }
    },

    async loadGajiSkemaTetap() {
      if (!this.gajiSkemaTetapStore) {
        this.gajiSkemaTetapStore =
          await this.gajiSettingStore.getGajiSkemaTetap();
      }
    },

    async loadGajiSkemaCapeg() {
      if (!this.gajiSkemaCapegStore) {
        this.gajiSkemaCapegStore =
          await this.gajiSettingStore.getGajiSkemaCapeg();
      }
    },

    async loadGajiSkemaHonor() {
      if (!this.gajiSkemaHonorStore) {
        this.gajiSkemaHonorStore =
          await this.gajiSettingStore.getGajiSkemaHonor();
      }
    },

    async loadGajiSkemaKontrak() {
      if (!this.gajiSkemaKontrakStore) {
        this.gajiSkemaKontrakStore =
          await this.gajiSettingStore.getGajiSkemaKontrak();
      }
    },

    async loadGajiSkemaKomponen() {
      if (!this.gajiSkemaKomponenStore) {
        this.gajiSkemaKomponenStore =
          await this.gajiSettingStore.getGajiSkemaKomponenStore();
      }
    },

    async lihatGapok(data) {
      this.popupRumusTitle = data.nama;
      this.popupGapokId = data.id;
      this.popupGapokVisible = true;
      this.popupRumusVisible = true;
    },

    async lihatRumus(data) {
      this.popupGajiSkemaId = data.id;
      this.popupRumusTitle = data.nama;
      this.popupGapokVisible = false;
      this.popupRumusVisible = true;
    },
    async absenCheckExists() {
      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      await axios
        .post(`${API_BASE_URL}/absen_check_exists`, this.gajiPeriodeTgl, config)
        .then((response) => {
          if (response.data.status) {
            this.generateGaji();
          } else {
            notify(response.data.message, response.data.notify_type);
          }
        })
        .catch((error) => {
          this.popupLoadingVisible = false;
          notify(
            "Pengecekan absensi gagal. " + error.response.data.message,
            "error",
          );
        });
    },
    async generateGaji() {
      //tambahkan gaji_periodes, generated true
      this.popupLoadingVisible = true;

      const config = {
        headers: {
          Authorization: api.defaults.headers.common["Authorization"],
          "content-type": "application/json",
        },
      };
      await axios
        .post(
          `${API_BASE_URL}/gaji`,
          [this.gajiPeriodeId, false, auth.getUser().id],
          config,
        )
        .then((response) => {
          this.popupLoadingVisible = false;
          notify(response.data.message, response.data.notify_type);
          this.refreshDatagrid("gridRef");
        })
        .catch((error) => {
          this.popupLoadingVisible = false;
          notify("Penggajian gagal dilaksanakan. " + error.message, "error");
          this.refreshDatagrid("gridRef");
        });
    },
    formatMonth(e) {
      // const date = DateTime.local().setLocale("id");
      const isoDateString = e.split("/").reverse().join("-") + "-01";
      const date = DateTime.fromISO(isoDateString).setLocale("id");

      return date.monthLong + " " + date.year;
    },

    gajiTemplate(cellElement, cellInfo) {
      cellElement.innerHTML = "";
      const wrapper = document.createElement("div");
      const sections = [
        {
          label: "Skema gaji pokok:",
          value: cellInfo.data.gaji_pokok_skema_nama,
          gapok: cellInfo.data.gaji_pokok_skema_id,
          id: cellInfo.data.gaji_pokok_skema_id,
          nama: cellInfo.data.gaji_pokok_skema_nama,
        },
        {
          label: "Direktur Utama:",
          value: cellInfo.data.gaji_skema_dirut_nama,
          id: cellInfo.data.gaji_skema_dirut_id,
          rumus: cellInfo.data.gaji_skema_dirut_id,
          nama: cellInfo.data.gaji_skema_dirut_nama,
        },
        {
          label: "Direktur Umum:",
          value: cellInfo.data.gaji_skema_dirum_nama,
          id: cellInfo.data.gaji_skema_dirum_id,
          rumus: cellInfo.data.gaji_skema_dirum_id,
          nama: cellInfo.data.gaji_skema_dirum_nama,
        },
        {
          label: "Direktur Teknik:",
          value: cellInfo.data.gaji_skema_dirtek_nama,
          id: cellInfo.data.gaji_skema_dirtek_id,
          rumus: cellInfo.data.gaji_skema_dirtek_id,
          nama: cellInfo.data.gaji_skema_dirtek_nama,
        },
        {
          label: "Dewan Pengawas:",
          value: cellInfo.data.gaji_skema_dewas_nama,
          id: cellInfo.data.gaji_skema_dewas_id,
          rumus: cellInfo.data.gaji_skema_dewas_id,
          nama: cellInfo.data.gaji_skema_dewas_nama,
        },
        {
          label: "Pegawai tetap:",
          value: cellInfo.data.gaji_skema_tetap_nama,
          id: cellInfo.data.gaji_skema_tetap_id,
          rumus: cellInfo.data.gaji_skema_tetap_id,
          nama: cellInfo.data.gaji_skema_tetap_nama,
        },
        {
          label: "Calon pegawai:",
          value: cellInfo.data.gaji_skema_capeg_nama,
          id: cellInfo.data.gaji_skema_capeg_id,
          rumus: cellInfo.data.gaji_skema_capeg_id,
          nama: cellInfo.data.gaji_skema_capeg_nama,
        },
        {
          label: "Pekerja honor:",
          value: cellInfo.data.gaji_skema_honor_nama,
          id: cellInfo.data.gaji_skema_honor_id,
          rumus: cellInfo.data.gaji_skema_honor_id,
          nama: cellInfo.data.gaji_skema_honor_nama,
        },
        {
          label: "Pekerja kontrak:",
          value: cellInfo.data.gaji_skema_kontrak_nama,
          id: cellInfo.data.gaji_skema_kontrak_id,
          rumus: cellInfo.data.gaji_skema_kontrak_id,
          nama: cellInfo.data.gaji_skema_kontrak_nama,
        },
      ];

      sections.forEach((section) => {
        // Create a div for each section
        const sectionDiv = document.createElement("div");
        sectionDiv.style.marginBottom = "10px";

        // Add strong label
        const strongLabel = document.createElement("strong");
        strongLabel.textContent = section.label;
        sectionDiv.appendChild(strongLabel);

        // Add text value
        const valueSpan = document.createElement("span");
        valueSpan.textContent = " " + section.value;

        //BATAS AWAL

        valueSpan.style.cursor = "pointer"; // Show pointer cursor on hover
        valueSpan.title = "Lihat detail";
        valueSpan.addEventListener("click", () => {
          // Handle the click action, e.g., redirect or show a popup
          if (section.rumus) this.lihatRumus(section);
          else this.lihatGapok(section);
        });

        //BATAS AKHIR
        sectionDiv.appendChild(valueSpan);

        // If the section has an ID, append an image with a click event
        // if (section.rumus) {
        //   const img = document.createElement("img");
        //   img.src = require("@/assets/eye-solid.png"); // Assuming the image is available in assets
        //   img.alt = "Lihat rumus";
        //   img.title = "Lihat rumus";
        //   img.style.height = "16px";
        //   img.style.verticalAlign = "middle";
        //   img.style.cursor = "pointer"; // Makes it clear that it's clickable
        //   img.className = "clickable-image";
        //   img.setAttribute("data-id", section.id); // Add data-id for identification

        //   // Add click event listener to image
        //   img.addEventListener("click", () => {
        //     this.lihatRumus(section);
        //   });
        //   // Append the image to the section
        //   sectionDiv.appendChild(img);
        // }

        // Append the section div to the wrapper
        wrapper.appendChild(sectionDiv);
      });

      // Append the wrapper to the cell element
      cellElement.appendChild(wrapper);
    },

    gajiListTemplate(data, flag) {
      var text = "";
      var type = "";
      var visible = true;
      if (data.data.generated) {
        text = "Lihat gaji";
        type = "success";
      } else {
        text = "Buat gaji";
        type = "danger";
        if (!this.can("gaji-create")) visible = false;
      }

      if (flag === "text") return text;
      else if (flag === "type") return type;
      else if (flag === "visible") return visible;
    },
    clickGaji(data) {
      if (data.data.generated) {
        const url = this.$router.resolve({
          name: "gaji-list-custom",
          query: { id: data.data.id, tgl: data.data.tgl },
        }).href;

        window.location.href = url;
      } else {
        //buat gaji baru
        if (this.can("gaji-create")) {
          this.gajiPeriodeId = data.data.id;
          this.gajiPeriodeTgl = data.data.tgl;
          this.popupWarningVisible = true;
        }
      }
    },
    formattedDate(tgl) {
      const jsDate = new Date(tgl);
      const dt = DateTime.fromJSDate(jsDate).setZone("Asia/Makassar");
      const convert = dt
        .setLocale("id")
        .toFormat("cccc dd MMMM yyyy HH:mm:ss 'WITA'");
      const originalDate = DateTime.fromFormat(
        convert,
        "cccc dd MMMM yyyy HH:mm:ss 'WITA'",
        { locale: "id" },
      );

      const newDate = originalDate.plus({ hours: 8 });
      const formattedNewDate = newDate.toFormat(
        "cccc dd MMMM yyyy HH:mm:ss 'WITA'",
      );
      return formattedNewDate;
    },
    userPrint(data, flag) {
      var nama = "";
      var tgl = "";
      if (flag === "created") {
        nama = data.data.createdByUser.name;
        tgl = this.formattedDate(data.data.created_at);
      } else if (data.data.updatedByUser) {
        nama = data.data.updatedByUser.name;
        tgl = this.formattedDate(data.data.updated_at);
      }

      if (_.isEmpty(nama)) nama = "";
      return nama + "<br>" + tgl;
    },
    buttonStatus(data, flag) {
      var type = this.commonStore.penggajianStatusStore.find(
        (g) => g.nama === data.value,
      ).warna;
      // var text = this.gajiStatusSource.find((g) => g.id === data.value).nama;
      var text = this.commonStore.penggajianStatusStore.find(
        (g) => g.nama === data.value,
      ).nama;

      if (flag === "type") return type;
      else return text;
    },
    can,
    addPeriodeVisible() {
      this.popupVisible = true;
    },
    formatDateISO(dateOri) {
      const date = DateTime.fromJSDate(new Date(dateOri));
      return date.toFormat("yyyy-MM-dd");
    },
    async addPeriode(e) {
      const result = e.validationGroup.validate();
      if (result.isValid) {
        this.gajiPeriode.tgl = this.formatDateISO(this.gajiPeriode.tgl);
        const config = {
          headers: {
            Authorization: api.defaults.headers.common["Authorization"],
            "content-type": "application/json",
          },
        };

        await axios
          .post(`${API_BASE_URL}/gajiPeriode`, this.gajiPeriode, config)
          .then((response) => {
            this.$refs.gridRef.instance.getDataSource().reload();
            this.popupVisible = false;

            notify(response.data.message, response.data.notify_type);
          })
          .catch((error) => {
            console.error(error);
            this.popupVisible = false;
            notify("Periode Penggajian gagal ditambahkan", "error");
          });
      }
    },
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar KGB.xlsx",
          );
        });
      });
      e.cancel = true;
    },

    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    onPageChanged(e) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    getOptions(data) {
      return [
        {
          text: "Lihat rekap",
          tgl: data.data.tgl,
          row_key: data.key,
        },

        {
          text: "Log Perubahan Data",
          tgl: data.data.tgl,
          row_key: data.key,
        },
        // other options...
      ];
    },

    onContextMenuPreparing(e) {
      if (e.target == "content") {
        e.itemData = {
          tgl: e.row.data.tgl,
          row_key: e.row.data.id,
        };
        // e.items can be undefined
        if (e.row.isEditing) return;
        if (!e.items) e.items = [];

        e.items.push({
          text: "Lihat rekap",
          icon: "money",
          onItemClick: () => {
            e.itemData.text = "Lihat rekap";
            this.onItemClick(e);
          },
        });

        e.items.push({
          text: "Log Perubahan Data",
          icon: "clock",
          onItemClick: () => {
            e.itemData.text = "Log Perubahan Data";
            this.$refs.logPopup.showBySubject(e.row.key, "GajiPeriode");
          },
        });
      }
    },

    onItemClick(e) {
      const tgl = e.itemData.tgl;
      const rowKey = e.itemData.row_key;

      if (e.itemData.text === "Lihat rekap") {
        const url = this.$router.resolve({
          name: "gaji-rekap-v2",
          query: { filter: tgl },
        }).href;
        window.open(url, "_blank");
      }
      if (e.itemData.text === "Log Perubahan Data") {
        this.$refs.logPopup.showBySubject(rowKey, "GajiPeriode");
      }
    },
  },
};
</script>
